import { Injectable } from '@angular/core';

const TOKEN_KEY = 'parking-auth-token';
const REFRESH_TOKEN_KEY = 'parking-auth-refresh-token';
const USER_KEY = 'parking-auth-user';

@Injectable({
  providedIn: 'root',
})
export class TokenStorageService {
  constructor() {}

  signOut(): void {
    localStorage.clear();
    setTimeout(() => {
      window.location.reload();
    }, 2000);
  }

  public saveToken(token: string): void {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.setItem(TOKEN_KEY, token);
  }

  public getToken(): string {
    return localStorage.getItem(TOKEN_KEY) || '';
  }

  public saveRefreshToken(refreshToken: string): void {
    localStorage.removeItem(REFRESH_TOKEN_KEY);
    localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
  }

  public getRefreshToken(): string {
    return localStorage.getItem(REFRESH_TOKEN_KEY) || '';
  }

  public saveUser(user: any): void {
    localStorage.removeItem(USER_KEY);
    localStorage.setItem(USER_KEY, JSON.stringify(user));
  }

  public getUser(): any {
    try {
      return JSON.parse(localStorage.getItem(USER_KEY) || '');
    } catch (error) {
      console.log(error);
    }
  }

  public isAdmin(): boolean {
    const user = this.getUser();
    return user && user.role === 'admin';
  }
}
